import styled, { css } from 'styled-components/macro';

import { ReactComponent as MaintenanceClipboardSvg } from 'components/svg/Clipboard.svg';
import { large, medium } from 'styles/breakpoints';
import { container } from 'styles/layout';
import {
  eyebrow,
  formHeadingThin,
  heading,
  paragraph,
} from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Container = styled.div`
  ${container}

  ${medium`
    max-width: 325px;
  `}

  ${large`
    max-width: 375px;
  `}
`;

export const Header = styled.h1`
  ${heading}

  margin: 26px 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;

export const SubHeader = styled.h2`
  ${eyebrow}

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;

export const Description = styled.h3`
  ${formHeadingThin}

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;

export const InstructionsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  ${large`
    align-items: flex-start;
    justify-content: center;
  `}
`;

export const Instructions = styled.p`
  ${paragraph}

  margin: auto;
  text-align: left;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}

  ${large`
    padding-right: 35px;
  `}
`;

const svgStyles = css`
  flex: 1 0 auto;
  margin: 0 15px 0 0;

  [data-svg-class='ServiceTypeButton-image-stroke'] {
    stroke-width: 1.6;
  }

  ${({ theme }: IWithThemeProps) => large`
    flex: 0 1 auto;
    margin: 0 0 46px;
    transform: scale(1);
    transition: transform ${theme.transitionDurationPrimary} ease;

    [data-svg-class="ServiceTypeButton-image-fill"] {
      fill: ${theme.topSvgFill};
      transition: fill ${theme.transitionDurationPrimary} ease;
    }

    [data-svg-class="ServiceTypeButton-image-stroke"] {
      stroke-width: 1;
    }
  `}
`;

export const ClipboardSvg = styled(MaintenanceClipboardSvg)`
  ${svgStyles}

  height: 140px;
  margin: 0 19px 0 8px;
  width: 91px;

  ${large`
    height: 143px;
    margin: 0 17px 0 17px;
    width: 400px;
  `}
`;

export const HorizontalLine = styled.hr`
  margin: 28px 0 28px;
  width: 100%;

  ${({ theme }: IWithThemeProps) => `
    border-color: ${theme.topForegroundPrimary};
  `}

  ${large`
    margin: 22px 0 22px;
  `}
`;

export const Phone = styled.h1`
  ${heading}

  font-size: 24px;
  line-height: 29px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;
